export default __webpack_public_path__ + "static/media/Objective.7e68bbc7.woff2";